export const adjust_credits = {
  total_credits: {
    fieldPath: 'total_credits',
    errorFieldPath: 'total_credits',
    fieldReadPath: 'total_credits',
    name: 'total_credits',
    label: 'global.subscription.total_credits.label',
    inputType: 'input-group',
    options: [],
    id: 'global-subscription__total-credits',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    tags: [],
    fieldAttributes: {
      autocomplete: 'off',
      type: 'number',
      step: '1',
    },
    fieldClass: 'global-subscription__total-credits--input',
    showError: true,
    errorClass: 'global-subscription__total-credits--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'global-subscription__total-credits--input-help',
    helpAttributes: [],
    help: 'global.subscription.total_credits.help',
    showFeedback: true,
    feedbackClass: 'global-subscription__total-credits--input-feedback',
    feedbackAttributes: [],
    feedback: 'global.subscription.total_credits.feedback',
    showLabel: true,
    labelClass: 'global-subscription__total-credits--input-label',
    showDefaultValueSwitch: false,
    defaultValueSwitchValue: 'default',
    iconFolder: '',
    translatable: false,
  },
  remaining_credits: {
    fieldPath: 'remaining_credits',
    errorFieldPath: 'remaining_credits',
    fieldReadPath: 'remaining_credits',
    name: 'remaining_credits',
    label: 'global.subscription.remaining_credits.label',
    inputType: 'input-group',
    options: [],
    id: 'global-subscription__remaining-credits',
    veeValidation: true,
    rules: ['nullable'],
    fieldAttributes: {
      autocomplete: 'off',
      type: 'number',
      step: '1',
    },
    fieldClass: 'global-subscription__remaining-credits--input',
    showError: true,
    errorClass: 'global-subscription__remaining-credits--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'global-subscription__remaining-credits--input-help',
    helpAttributes: [],
    help: 'global.subscription.remaining_credits.help',
    showFeedback: true,
    feedbackClass: 'global-subscription__remaining-credits--input-feedback',
    feedbackAttributes: [],
    feedback: 'global.subscription.remaining_credits.feedback',
    showLabel: true,
    labelClass: 'global-subscription__remaining-credits--input-label',
    mediaCollection: [],
    disabledByTags: [],
    showDefaultValueSwitch: false,
    defaultValueSwitchValue: 'default',
    conditionalClass: null,
    translatable: false,
    order: 70,
  },
};
